import { render, staticRenderFns } from "./SmallCardWithIcon.vue?vue&type=template&id=7c1b76c7&scoped=true&"
import script from "./SmallCardWithIcon.vue?vue&type=script&lang=js&"
export * from "./SmallCardWithIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1b76c7",
  null
  
)

export default component.exports